import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.form,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "表单名称",
      "prop": "formName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请填写表单名称"
    },
    model: {
      value: _vm.form.formName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "formName", $$v);
      },
      expression: "form.formName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "表单类型",
      "prop": "cateId"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择表单类型"
    },
    model: {
      value: _vm.form.cateId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cateId", $$v);
      },
      expression: "form.cateId"
    }
  }, _vm._l(_vm.cateList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.cateId
      }
    }, [_vm._v(" " + _vm._s(item.cateName) + " ")]);
  }), 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "状态",
      "prop": "fillStatus"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择表单状态"
    },
    model: {
      value: _vm.form.fillStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fillStatus", $$v);
      },
      expression: "form.fillStatus"
    }
  }, _vm._l(_vm.fillStautsList, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.itemKey
      }
    }, [_vm._v(" " + _vm._s(item.itemName) + " ")]);
  }), 1)], 1)], 1)], 1), _vm.expand ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "发起时间",
      "prop": "timeValue"
    }
  }, [_c('a-range-picker', {
    attrs: {
      "value-format": "YYYY-MM-DD",
      "placeholder": ['开始时间', '结束时间']
    },
    on: {
      "change": _vm.onChange,
      "ok": _vm.onOk
    },
    model: {
      value: _vm.form.timeValue,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "timeValue", $$v);
      },
      expression: "form.timeValue"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "申请流水号",
      "prop": "fillId"
    }
  }, [_c('a-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "formatter": function formatter(value) {
        return "".concat(value);
      },
      "parser": function parser(value) {
        return value.replace('.', '');
      },
      "placeholder": "请输入申请流水号"
    },
    model: {
      value: _vm.form.fillId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fillId", $$v);
      },
      expression: "form.fillId"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "概述",
      "prop": "summary"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入概述"
    },
    model: {
      value: _vm.form.summary,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "summary", $$v);
      },
      expression: "form.summary"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.expand ? _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "表单内容",
      "prop": "content"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入表单内容"
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryTableList
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": _vm.restForm
    }
  }, [_vm._v("重置")]), _c('a', {
    style: {
      marginLeft: '5px',
      fontSize: '12px'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(" " + _vm._s(_vm.expand ? '收起' : '展开') + " "), _c('a-icon', {
    attrs: {
      "type": _vm.expand ? 'up' : 'down'
    }
  })], 1)], 1)])], 1)]), _c('a-card', {
    ref: "searchExpand",
    staticClass: "search-card",
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('div', [_c('a-table', {
    staticClass: "dictTable",
    attrs: {
      "customRow": _vm.rowClick,
      "data-source": _vm.dataSource,
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "size": "middle",
      "loading": _vm.loading,
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.onChangeTable
    },
    scopedSlots: _vm._u([{
      key: "dbFormName",
      fn: function fn(dbFormName, record) {
        return [_c('span', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "dblclick": function dblclick($event) {
              return _vm.dbTwoClick(record);
            }
          }
        }, [_vm._v(" " + _vm._s(record.formName) + " ")])];
      }
    }, {
      key: "formNameTmp",
      fn: function fn(text, record) {
        return [_c('div', {
          ref: "popclass"
        }, [_c('a-popconfirm', {
          attrs: {
            "title": "确认取消跟踪该流程吗？",
            "ok-text": "是",
            "cancel-text": "否",
            "id": "btnn",
            "visible": _vm.visible && record.processInstanceId == _vm.visibleId
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.handlepopConfirmConfirm(record);
            },
            "cancel": function cancel($event) {
              return _vm.handlepopConfirmCancel(record);
            },
            "visibleChange": function visibleChange($event) {
              return _vm.handleVisibleChange(record);
            }
          }
        }, [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.toSave(record);
            }
          }
        }, [record.trackStatus == 2 ? _c('img', {
          attrs: {
            "src": require("../../../assets/img/flag_red.png"),
            "alt": ""
          }
        }) : _c('img', {
          attrs: {
            "src": require("../../../assets/img/flag_grey.png"),
            "alt": ""
          }
        })])])], 1)];
      }
    }, {
      key: "cateType",
      fn: function fn(text, record) {
        return [_vm._v(" " + _vm._s(_vm.cateList.find(function (item) {
          return item.cateId == record.cateId;
        }).cateName) + " ")];
      }
    }, {
      key: "needId",
      fn: function fn(text, record) {
        return [_c('span', {
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(text))])];
      }
    }, {
      key: "statusType",
      fn: function fn(text, record) {
        return [_c('a-tag', {
          attrs: {
            "color": _vm.fillStautsColorList.find(function (item) {
              return item.itemKey == record.fillStatus;
            }).itemName
          }
        }, [_vm._v(" " + _vm._s(_vm.fillStautsList.find(function (item) {
          return item.itemKey == record.fillStatus;
        }).itemName) + " ")])];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.onViewWaitMeApply(text, record);
            }
          }
        }, [_vm._v(" 查看 ")])], 1)];
      }
    }])
  })], 1), _c('a-drawer', {
    attrs: {
      "title": "查看表单",
      "width": 1600,
      "visible": _vm.viewVisible,
      "destroyOnClose": "",
      "body-style": {
        paddingBottom: '80px'
      }
    },
    on: {
      "close": _vm.onViewClose
    }
  }, [_c('fm-generate-form', {
    ref: "generateForm",
    attrs: {
      "data": _vm.formData,
      "value": _vm.viewData
    }
  }), _c('div', {
    style: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1
    }
  }, [_c('a-button', {
    style: {
      marginRight: '8px'
    },
    on: {
      "click": _vm.onViewClose
    }
  }, [_vm._v("取消")]), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onViewClose
    }
  }, [_vm._v("确认")])], 1)], 1), _c('a-drawer', {
    attrs: {
      "title": "编辑表单",
      "width": 1000,
      "closable": true,
      "visible": _vm.editVisible,
      "body-style": {
        paddingBottom: '80px'
      },
      "destroyOnClose": "",
      "zIndex": 999
    },
    on: {
      "close": _vm.onEditClose
    }
  }, [_c('a-form-model', {
    ref: "addForm",
    attrs: {
      "model": _vm.formObject,
      "rules": _vm.rules,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId"
    }
  }, [_c('a-cascader', {
    style: {
      width: '100%',
      textAlign: 'left'
    },
    attrs: {
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.formObject.organPostId,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "organPostId", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObject.organPostId"
    }
  })], 1)], 1)], 1)], 1), _c('br'), _c('fm-generate-form', {
    ref: "editGenerateForm",
    attrs: {
      "data": _vm.formData,
      "value": _vm.editData
    }
  }), _c('div', {
    style: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1
    }
  }, [_c('a-button', {
    style: {
      marginRight: '8px'
    },
    on: {
      "click": _vm.onEditClose
    }
  }, [_vm._v("取消")]), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确认")])], 1)], 1), _c('a-modal', {
    attrs: {
      "title": "指定节点审核人",
      "visible": _vm.auditUserVisible
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form1,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_vm._l(_vm.flowApproverSetList, function (item, index) {
    return [_c('a-form-item', {
      attrs: {
        "label": item.taskName
      }
    }, [_c('select-person', {
      ref: "personPick",
      refInFor: true,
      attrs: {
        "tabList": _vm.userGroupTabList,
        "width": "100%"
      },
      model: {
        value: _vm.userGroupObj[item.taskDefKey],
        callback: function callback($$v) {
          _vm.$set(_vm.userGroupObj, item.taskDefKey, $$v);
        },
        expression: "userGroupObj[item.taskDefKey]"
      }
    })], 1)];
  })], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };